import { ValidatorFn } from '@angular/forms';
import { AllFields } from './property';

export interface FieldValidator {
  name: string;
  validator: ValidatorFn;
  message: string;
}

export interface FieldConfigList {
  title: string;
  fields: FieldConfig[];
}

export interface FieldSubControl {
  type?: string;
  label?: string;
  inputType?: string;
  name: string;
  disabled?: boolean;
  validations?: FieldValidator[];
}

export interface FieldConfig {
  label?: string;
  name?: AllFields; // Field Config works for any field in the property
  class?: string;
  disabled?: boolean;
  inputType?: string;
  buttonType?: string; // img or null
  functionName?: string; // for on click handling
  options?: string[] | Record<string, any>[];
  collections?: any;
  type: string;
  value?: any;
  img?: string; // if there are images to show with buttons
  multiple?: boolean; // for multi-select
  validations?: FieldValidator[];
  subControls?: FieldSubControl[];
  subCategory?: string; // for grouping fields in sections, e.g. acquisition costs
  helperText?: string; // for additional info below the field
}

export type FieldControlFields = keyof FieldConfig;
